import { useEffect, useState, useRef } from "react";
import {
  Box,
  CircularProgress,
  ClickAwayListener,
  Grow,
  IconButton,
  MenuList,
  Paper,
  Popper,
  Typography,
  Badge,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import NotificationIcon from "../icons/NotificationIcon";
import { CloseIcon } from "../icons/CloseIcon";
import { NotificationItem } from "../NotificationPopUp/NotificationItem";
import {
  useLazyGetNotificationsCountQuery,
  useLazyGetNotificationsQuery,
  useMarkNotificationAsReadMutation,
} from "../../../middleware/notificationApi";
import noLinkControllerSound from "../../../sounds/Buzzer.wav";
import "./styles.css";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    minWidth: "18px",
    height: "18px",
    fontSize: "8px",
    border: `1px solid white`,
    backgroundColor: "var(--accent)",
    color: "white",
    padding: "0px",
  },
}));

const noLinkControllerAudio = new Audio(noLinkControllerSound);
noLinkControllerAudio.preload = "auto";

export const NoLinkControllerPopUp = () => {
  const [notifications, setNotifications] = useState([]);
  const [notificationsCount, setNotificationsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const anchorRef = useRef(null);
  const { t } = useTranslation();

  const [getNotification, { error: errorNotif, refetch: refetchNotifications /* isLoading */ }] =
    useLazyGetNotificationsQuery();

  const [getNotificationsCount, { error: errorNotifcount }] = useLazyGetNotificationsCountQuery();
  const [markNotificationAsRead, { error }] = useMarkNotificationAsReadMutation();

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const playNotificationSound = () => {
    try {
      noLinkControllerAudio.currentTime = 0;
      noLinkControllerAudio.play().catch((e) => {
        console.error("Audio playback error:", e);
      });
    } catch (e) {
      console.error("Audio error:", e);
    }
  };

  const stopSoundInterval = () => {
    // if (soundIntervalRef.current) {
    //   clearInterval(soundIntervalRef.current);
    //   soundIntervalRef.current = null;
    // }
    noLinkControllerAudio.pause();
    noLinkControllerAudio.currentTime = 0;
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
    stopSoundInterval();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      getNotificationsCount({
        notificationTypes: [14, 15],
        filters: "&isLimitBySession=false",
      }).then((data) => {
        setNotificationsCount((prev) => {
          if (data.data > prev && prev !== 0) {
            playNotificationSound();
          }
          return data.data;
        });
      });
    }, 5000); // Вызов функции callApi каждые 5 секунд

    return () => clearInterval(interval);
  }, []);

  const fetchData = async () => {
    try {
      const response = await getNotification({
        pageNumber: 0,
        notificationTypes: [14, 15],
        filters: "&isLimitBySession=false&sortByFireStatus=false&sortByMessageTime=false",
      });
      setNotifications({
        ...response?.data,
        hasMore: response?.data?.data.length < response?.data.recordsCount ? true : false,
      });
    } catch (error) {
      console.error("error");
    }
  };

  useEffect(() => {
    if (open) {
      fetchData();
    }
  }, [open]);

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  // const markNotification = () => {
  //   markNotificationAsRead({ notificationIds: [] }).then(({ data, error }) => {
  //     if (!error) {
  //       fetchData();
  //       getNotificationsCount().then((data) => setNotificationsCount(data.data));
  //     }
  //   });
  // };

  const notiffetchData = () => {
    setTimeout(() => {
      getNotification({
        pageNumber: pageNumber + 1,
        notificationTypes: [14, 15],
        filters: "&isLimitBySession=false&sortByFireStatus=false&sortByMessageTime=false",
      }).then(({ data, isSuccess }) => {
        setPageNumber((prev) => prev + 1);
        setNotifications({
          ...notifications,
          hasMore: data?.data.length + notifications?.data.length < data.recordsCount ? true : false,
          data: [...notifications?.data, ...data.data],
        });
        setLoading(false);
      });
    }, 1000);
  };

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;

    if (bottom >= 1 && bottom <= 10 && !loading && notifications?.hasMore) {
      setLoading(true);
      notiffetchData();
    }
  };

  return (
    <Box>
      <div className="notification-icon" ref={anchorRef} onClick={handleToggle}>
        <StyledBadge
          sx={{ top: "-9px", right: "-24px", color: "white" }}
          badgeContent={Math.min(notificationsCount, 99) || 0}
        ></StyledBadge>
        <NotificationIcon />
      </div>

      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper className="paper-wrapper">
              <Box sx={{ position: "absolute", right: "40px", top: "40px" }}>
                <IconButton onClick={handleClose} sx={{ padding: 0 }}>
                  <CloseIcon />
                </IconButton>
              </Box>

              <div className="notification-wrapper">
                <div className="notification-title-wrapper">
                  <p className="notification-title">{t("label:notifications")}</p>
                </div>

                {/* {notifications?.recordsCount > 0 ? (
                  <Box style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      variant="text"
                      onClick={() => markNotification(notifications.data.map((notification) => notification?.id))}
                    >
                      <Typography className="mark-laber "></Typography>
                    </Button>
                  </Box>
                ) : (
                  ""
                )} */}

                <ClickAwayListener onClickAway={handleClose}>
                  {notifications?.recordsCount > 0 ? (
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                      onScroll={handleScroll}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                        height: "50vh",
                        overflow: "hidden",
                        overflowY: "auto",
                        paddingBottom: "0px",
                      }}
                    >
                      {notifications.data.map((item) => {
                        return <NotificationItem key={item?.id} notification={item} />;
                      })}

                      {loading && (
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <CircularProgress />
                        </Box>
                      )}
                    </MenuList>
                  ) : (
                    <Box
                      sx={{
                        height: "400px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography>{t("label:no_notifications")}</Typography>
                    </Box>
                  )}
                </ClickAwayListener>
              </div>
              {/* <div className="notification-footer">
                <button onClick={() => markNotification([])} className="info">
                  {t("label:mark_all_as_read")}
                </button>
              </div> */}
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
};
